import { Modal } from "antd";

const DeleteComponent = (props) => {
  const {
    visible = false,
    title,
    onCancel = () => { },
    onOk = () => { },
    formVal,
    content
  } = props

  return (
    <Modal
      visible={visible}
      title={title}
      centered
      closable={false}
      maskClosable={false}
      onCancel={onCancel}
      onOk={() => onOk(formVal)}
      cancelText="取消"
      okText="确认"
    >
      <p>{content}</p>
    </Modal>
  )
}

export default DeleteComponent